import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=fc027868&scoped=true"
import script from "./ListOrder.vue?vue&type=script&lang=ts"
export * from "./ListOrder.vue?vue&type=script&lang=ts"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=fc027868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc027868",
  null
  
)

export default component.exports